/**
 * Status Bar Component
 * Viser kort status gennem hele processen
 */

import '../styles/components/status-bar.css'

const STATUS_CONFIG = {
  created: {
    label: 'Kort lavet',
    icon: '📝',
    color: '#667eea'
  },
  sender_responded: {
    label: 'Kort lavet og udfyldt af afsender',
    icon: '✅',
    color: '#48bb78'
  },
  opened: {
    label: 'Kort åben',
    icon: '👀',
    color: '#4299e1'
  },
  recipient_responded: {
    label: 'Modtager har svaret',
    icon: '💬',
    color: '#ed8936'
  },
  ready_for_feedback: {
    label: 'Klar til at se feedback',
    icon: '🎉',
    color: '#48bb78'
  }
}

function StatusBar({ status, showShareMessage = false }) {
  const config = STATUS_CONFIG[status] || STATUS_CONFIG.created
  
  return (
    <div className="status-bar" style={{ borderLeftColor: config.color }}>
      <div className="status-content">
        <span className="status-icon">{config.icon}</span>
        <span className="status-text">{config.label}</span>
        {showShareMessage && (
          <span className="share-message">
            → Send dette link til den der skal have det
          </span>
        )}
      </div>
      {status === 'ready_for_feedback' && (
        <div className="status-action">
          <span className="ready-indicator">✨ Klar!</span>
        </div>
      )}
    </div>
  )
}

export default StatusBar
